import React from 'react';
import './NavigationPageTitle.scss';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { useA11y } from '@context/Utils/A11y';
import Icons from '@core/Utils/Icons/Icons';

// REFACTOR: use Ta11yText component (for later)

export function NavigationPageTitle({
  title,
  desc,
  replaceTitle,
  replaceTitleBy,
  replaceDesc,
  replaceDescBy,
  isBackButton,
  onButtonClick,
  variant = 'lg',
  headingTag = 'h1' 
}) {
  const { tA11yTranslate } = useA11y();
  const HeadingTag = headingTag;  

  return (
    <header className="navigation-page-title text-primary">
      {variant === 'flex-lg' || variant === 'flex-sm' ? (
        <div className="d-flex align-items-center">
          {isBackButton && (
            <button
              type="button"
              className="border-0 rounded bg-transparent p-0 me-48"
              aria-label={tA11yTranslate('ek_global_icn-back_aria').ariaLabel}
              onClick={onButtonClick}>
              <Icons name='ARROW_BACK' colorType='dark' width={24} />
            </button>
          )}
          {tA11y(title).isHtml ? (
            <HeadingTag
              className={`m-0 ${variant === 'flex-lg' ? 'ek-h1' : 'ek-h2'}`}
              dangerouslySetInnerHTML={{
                __html: tA11y(title).content.replace(replaceTitle, replaceTitleBy)
              }}
            />
          ) : (
            <HeadingTag className={`m-0 ${variant === 'flex-lg' ? 'ek-h1' : 'ek-h2'}`}>
              {tA11y(title).content.replace(replaceTitle, replaceTitleBy)}
            </HeadingTag>
          )}
        </div>
      ) : (
        <>
          {isBackButton && (
            <div className={`${variant === 'lg' ? 'pb-48' : 'pb-24'}`}>
              <button
                type="button"
                className="border-0 rounded bg-transparent p-0"
                aria-label={tA11yTranslate('ek_global_icn-back_aria').ariaLabel}
                onClick={onButtonClick}>
                  <Icons name='ARROW_BACK' colorType='dark' width={24} />
              </button>
            </div>
          )}
          <div className="text-break">
            {variant === 'lg' &&
              (tA11y(title).isHtml ? (
                <HeadingTag
                  className="ek-h1 m-0 lg"
                  dangerouslySetInnerHTML={{
                    __html: tA11y(title).content.replace(replaceTitle, replaceTitleBy)
                  }}
                />
              ) : (
                <HeadingTag className="ek-h1 m-0 lg">
                  {tA11y(title).content.replace(replaceTitle, replaceTitleBy)}{' '}
                </HeadingTag>
              ))}

            {variant === 'sm' &&
              (tA11y(title).isHtml ? (
                <HeadingTag
                  className="ek-h2 m-0 sm"
                  dangerouslySetInnerHTML={{
                    __html: tA11y(title).content.replace(replaceTitle, replaceTitleBy)
                  }}
                />
              ) : (
                <HeadingTag className="ek-h2 m-0 sm">
                  {tA11y(title).content.replace(replaceTitle, replaceTitleBy)}{' '}
                </HeadingTag>
              ))}

            {desc &&
              (tA11y(desc).isHtml ? (
                <div
                  className={`ek-copy-16-medium ${variant === 'flex-lg' || headingTag == 'h1' ? 'mt-24' : 'mt-40'}`}
                  dangerouslySetInnerHTML={{
                    __html: tA11y(desc).content.replace(replaceDesc, replaceDescBy)
                  }}
                />
              ) : (
                <div className={`ek-copy-16-medium ${variant === 'flex-lg' || headingTag == 'h1' ? 'mt-24' : 'mt-40'}`}>
                  {tA11y(desc).content.replace(replaceDesc, replaceDescBy)}
                </div>
              ))}
          </div>
        </>
      )}
    </header>
  );
}

export default NavigationPageTitle;
